import React from 'react';

const CustomButton = props => (
  <span className={props.classIconName} onClick={props.onClickHandler}>
    {props.body}
  </span>
);

export default CustomButton;
